<template>
    <v-autocomplete
        v-model="project"
        :items="projects2"
        :loading="projectsLoading"
        v-model:search="projectsSearch"
        no-filter
        hide-no-data
        hide-selected
        color="secondary"
        item-title="FullName"
        item-value="ProjectCode"
        label="Projects"
        placeholder="Search by project name or job number..."
        prepend-icon="mdi-briefcase"
        return-object
        clearable
        auto-select-first
    >
        <template v-slot:selection="data">
            <span class="text--typography1">
                {{ data.item.JobNameLong }}
            </span>
            <v-chip size="small" class="text--typography1">
                {{ data.item.ProjectRef }}
            </v-chip>
        </template>

        <template v-slot:item="data">
            <span class="text--typography1">
                {{ data.item.JobNameLong }}
            </span>
            <v-chip size="small" class="text--typography1">
                {{ data.item.ProjectRef }}
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import debounce from 'lodash.debounce'

const props = defineProps({
    initialProject: { type: String },
})
const emit = defineEmits(['changeProject'])

const store = useStore()

const projectsSearch = ref(null)
const selectedProject = ref(null)

const projects = computed(() => store.state.projects)
const projectsLoading = computed(() => store.state.projectsLoading)

const project = computed({
    get() {
        return selectedProject.value
    },
    set(value) {
        selectedProject.value = value
        emit('changeProject', projectString.value)
    },
})

const projects2 = computed(() => {
    if (project.value && projects.value.length === 0) return [project.value]
    return projects.value
})

const projectString = computed(() => {
    if (selectedProject.value) {
        const proj = selectedProject.value
        return `${proj.FullName}/${proj.JobNameLong}/${proj.JobNameShort}/${proj.ProjectCode}/${proj.ProjectRef}`
    }
    return ''
})

onMounted(() => {
    if (props.initialProject) {
        const parts = props.initialProject.split('/')
        if (parts.length === 5) {
            selectedProject.value = {
                FullName: parts[0],
                JobNameLong: parts[1],
                JobNameShort: parts[2],
                ProjectCode: parts[3],
                ProjectRef: parts[4],
            }
        }
    }
})

watch(projectsSearch, (val) => {
    if (!val) return
    if (typeof val === 'object') return
    debouncedGetProjects(val)
})

const debouncedGetProjects = debounce((val) => {
    store.commit('SET_PROJECTS_LOADING', true)
    store.dispatch('getProjects', val)
}, 250)
</script>
